import { numberWithCommas } from "js/utils";

export const normalizeFloat = (decimalNumbers = 2) => (value = "") => {
  if (!value && value !== 0) return "";

  let normalized = value.toString().trim();
  if (!normalized) return "";

  // Detectar si hay coma (separador decimal preferido)
  const hasComma = normalized.includes(",");
  const hasDot = normalized.includes(".");

  if (hasComma) {
    // Coma como separador decimal: eliminar todos los puntos (miles)
    normalized = normalized.replace(/\./g, "");
    normalized = normalized.replace(",", ".");
  } else if (hasDot) {
    // Punto: si hay múltiples, el último es decimal, los demás son miles
    const lastDotIndex = normalized.lastIndexOf(".");
    if (lastDotIndex !== normalized.indexOf(".")) {
      // Múltiples puntos: eliminar todos y dejar solo el último
      const beforeLastDot = normalized
        .slice(0, lastDotIndex)
        .replace(/\./g, "");
      const afterLastDot = normalized.slice(lastDotIndex + 1);
      normalized = beforeLastDot + "." + afterLastDot;
    }
  }

  // Eliminar todo lo que no sea dígito o punto decimal
  normalized = normalized.replace(/[^0-9.]/g, "");

  // No permitir separador sin dígitos
  const digitsCount = (normalized.match(/[0-9]/g) || []).length;
  if (digitsCount === 0) {
    return normalized.includes(".") ? "" : normalized;
  }

  const length = normalized.length - 1;
  const dotZero =
    normalized.includes(".") && normalized[normalized.length - 1] === "0";

  // Si termina en punto, devolver con coma para continuar escribiendo
  if (normalized[length] === ".") {
    return normalized.slice(0, -1) + ",";
  }

  // NO aplicar toFixed mientras el usuario está escribiendo
  // Solo devolver el valor normalizado tal cual
  return normalized;
};

export const formatFloat = (decimalNumbers = 2) => (value = "", name) => {
  if (value === "-") return value;
  if (!value && value !== 0) return undefined;

  let val = value.toString().trim();
  if (!val || !val.length) return undefined;

  const endsWithComma = val[val.length - 1] === ",";
  const raw = endsWithComma ? val.slice(0, -1) : val;

  // Detectar si tiene formato con puntos (miles) y coma (decimal)
  const hasComma = raw.includes(",");
  const hasDot = raw.includes(".");

  let cleaned;
  if (hasComma) {
    // Tiene coma: eliminar puntos (miles) y convertir coma a punto para parseFloat
    cleaned = raw.replace(/\./g, "").replace(",", ".");
  } else if (hasDot) {
    // Solo tiene punto: verificar si es decimal o miles
    const lastDotIndex = raw.lastIndexOf(".");
    const beforeLastDot = raw.slice(0, lastDotIndex);
    const afterLastDot = raw.slice(lastDotIndex + 1);

    // Si después del último punto hay 1-2 dígitos, es separador decimal
    // Si hay más de 2 dígitos, probablemente es miles (formato incorrecto)
    if (afterLastDot.length <= 2 && beforeLastDot.length > 0) {
      // Es separador decimal: eliminar solo los puntos de miles (antes del último)
      // Mantener el último punto como separador decimal
      const beforeLastDotCleaned = beforeLastDot.replace(/\./g, "");
      cleaned = beforeLastDotCleaned + "." + afterLastDot;
    } else {
      // Probablemente es miles o formato incorrecto, tratar como entero
      cleaned = raw.replace(/\./g, "");
    }
  } else {
    // No tiene separadores, es un entero
    cleaned = raw;
  }

  const num = parseFloat(cleaned);

  if (isNaN(num)) return "";

  return endsWithComma
    ? numberWithCommas(num, decimalNumbers) + ","
    : numberWithCommas(num, decimalNumbers);
};

export const intParser = (value = "") => {
  const val = value
    .toString()
    .replace(/\./g, "")
    .replace(",", ".");
  return !isNaN(parseInt(val)) ? parseInt(val) : null;
};
